export default __webpack_public_path__ + "static/media/MariaDB-WindowsTaskScheduler-Result09.4759a7fd.png";